import * as basicScroll from 'basicscroll';

export const queryId = (val, root = document) => root.querySelector(`[data-id=${val}]`);

const animateFeatureOrangeBar = () => {
  const orangeBar = queryId('ws-feature-orange-bar');

  const orangeBarWidth = basicScroll.create({
    elem: orangeBar,
    from: 'top-bottom',
    to: 'middle-middle',
    direct: true,
    props: {
      '--width-transform': {
        from: '1%',
        to: '100%',
      },
    },
  });

  orangeBarWidth.start();
};

const animateBestInClassGlobe = () => {
  const globe = basicScroll.create({
    elem: document.querySelector('.ws-best-in-class-globe'),
    from: 'top-bottom',
    to: 'bottom-top',
    direct: true,
    props: {
      '--translate-globe-transform': {
        from: '0%',
        to: '50%',
      },
    },
  });
  globe.start();
};

const Animations = () => {
  animateFeatureOrangeBar();
  animateBestInClassGlobe();
};

export default Animations;
